"use strict";

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circular = void 0;

var _react = require("react");

var _Velocity = require("./Velocity");

var _operators = require("rxjs/operators");

var Circular = function Circular(_ref) {
  var children = _ref.children,
      state = _ref.state;
  var position = state.position,
      rotate = state.rotate,
      frames = state.frames,
      distance = state.distance,
      direction = state.direction;
  var velocityState = (0, _react.useMemo)(function () {
    return [[0, rotate, frames, distance, direction].concat(_toConsumableArray(position)), [rotate / frames]];
  }, [rotate, frames, distance, direction].concat(_toConsumableArray(position)));

  var decorate = function decorate(children) {
    return function (pipe) {
      var obs = pipe((0, _operators.map)(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            _ref3$ = _slicedToArray(_ref3[0], 7),
            offset = _ref3$[0],
            rotate = _ref3$[1],
            frames = _ref3$[2],
            distance = _ref3$[3],
            direction = _ref3$[4],
            positionX = _ref3$[5],
            positionY = _ref3$[6];

        var halfRotate = rotate / 2;
        var velocity = distance / Math.sin(halfRotate) / 2;
        var initial = direction - halfRotate;
        var x = positionX + velocity * (Math.cos(initial) * Math.sin(offset) + Math.sin(initial) * Math.cos(offset) - Math.sin(initial));
        var y = positionY + velocity * (Math.sin(initial) * Math.sin(offset) - Math.cos(initial) * Math.cos(offset) + Math.cos(initial));
        var angle = initial + offset;
        return {
          x: x,
          y: y,
          angle: angle,
          rotate: rotate,
          frames: frames,
          distance: distance,
          direction: direction,
          position: position
        };
      }));
      return children(obs.pipe.bind(obs));
    };
  };

  return (0, _Velocity.Velocity)({
    state: velocityState,
    children: decorate(children)
  });
};

exports.Circular = Circular;
Circular.displayName = 'Gradient.Circular';